import { render, staticRenderFns } from "./PreConsulto.vue?vue&type=template&id=6094e2de&scoped=true&"
import script from "./PreConsulto.vue?vue&type=script&lang=js&"
export * from "./PreConsulto.vue?vue&type=script&lang=js&"
import style0 from "./PreConsulto.vue?vue&type=style&index=0&id=6094e2de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6094e2de",
  null
  
)

export default component.exports